export default "__VITE_ASSET__580f6481__"